import {
  SimplePieChart,
  SimplePieChartProps,
} from "@/common/charts/components/SimplePieChart";
import { useSegmentCount } from "@/company/data/useSegments";
import { useFlag } from "@reflag/react-sdk";
import { getFraction } from "@reflag/shared/utils/getFraction";

export function SegmentSizeIndicator({
  segmentId,
  ...rest
}: {
  segmentId?: string;
} & Omit<SimplePieChartProps, "value">) {
  const { isEnabled: segmentCountsDisabled } = useFlag(
    "disable-segment-counts",
  );
  const segmentCountsEnabled = !segmentCountsDisabled;
  const { data: segmentCount, isLoading } = useSegmentCount(segmentId, {
    enabled: segmentCountsEnabled,
  });

  return (
    <SimplePieChart
      loading={segmentCountsEnabled && isLoading}
      value={
        !segmentCount ||
        segmentCount.segmentCount === null ||
        segmentCount.allCount === null
          ? 0
          : getFraction(segmentCount.segmentCount, segmentCount.allCount) * 100
      }
      {...rest}
    />
  );
}
